// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"ed2ee5d9","185":"cc2a7417","275":"a16c4616","721":"1f6596ab","761":"94dab834"}[chunkId] + ".chunk.css";
};